module.exports = ".cls-1{fill:#006899}body.modal-open{overflow:hidden}"